module.exports = __webpack_public_path__ + "static/media/logo.d00b6e0a.svg";